import {
  PageHeader,
  SystemIcon,
  Button,
  Divider,
} from "@justworkshr/milo-components";
import { useEffect } from "react";
import FooterButton from "uicomponents/FooterButton";
import { trackPageViewUserStep } from "utils/analytics/trackEvent";
import HealthAppUpsellStepper from "./components/HealthAppUpsellStepper";
import { getAppType } from "utils/helper";
import styles from "./HealthApplicationStatus.module.css";
import {
  HEALTH_APP_STATUS_CONTENT,
  HEALTH_APP_UPSELL_STATUS_CONTENT,
} from "./utils/constants";

const HealthApplicationStatus = (): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageViewUserStep(9, "health app status page");
  }, []);

  const isHealthInsuranceUpsellApp = getAppType() === "HEALTH_INSURANCE_UPSELL";
  const pageCopy = isHealthInsuranceUpsellApp
    ? HEALTH_APP_UPSELL_STATUS_CONTENT
    : HEALTH_APP_STATUS_CONTENT;

  return (
    <div className={styles.healthApplicationStatusContainer}>
      <div className={styles.titleContainer}>
        <PageHeader
          className={styles.healthApplicationStatusHeader}
          title={pageCopy.pageTitle}
          linkPrevious={<a href={pageCopy.url}>{pageCopy.urlText}</a>}
        />
        <Divider spacing="xs" />
      </div>

      {isHealthInsuranceUpsellApp ? (
        <div className={styles.upsellContent}>
          <div className={styles.upsellHeadingText}>
            {pageCopy.pageHeadingText}
          </div>
          <HealthAppUpsellStepper />

          <FooterButton
            nextButtonText={pageCopy.footerButtonText}
            nextButtonHref={pageCopy.url}
          />
        </div>
      ) : (
        <div className={styles.healthApplicationStatusContent}>
          <SystemIcon
            iconName="check"
            color="inverse"
            size="medium"
            className={styles.checkIcon}
          />
          <p>Your application was successfully submitted.</p>
          <p>We’ll review it and reach out if we need any additional info. </p>
          <p>Otherwise, we’ll send a reply in 3-5 days.</p>
          <Button
            variant="outlined"
            as="a"
            href={pageCopy.url}
            className={styles.button}
          >
            {pageCopy.footerButtonText}
          </Button>
        </div>
      )}
    </div>
  );
};

export default HealthApplicationStatus;
